// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"MainContentWrapper_mainContent__Mh9_T"};